export function reducer(state, action) {
  switch (action.type) {
    case 'APPLY': {
      const next = typeof action.recipe === 'function' ? action.recipe(state) : action.recipe;
      return next;
    }
    case 'RESET':
      return action.data;
    default:
      return state;
  }
}
